// extracted by mini-css-extract-plugin
export default {"clearAll":"index_clearAll__y7kKZ","clearAllText":"index_clearAllText__5scVC"};